import { parseImportFile, type ParsedImport } from './import-parser.js'

const ACCEPTED_EXTENSIONS = ['.gpx', '.kml', '.kmz', '.geojson', '.json']

export const IMPORT_ACCEPT = ACCEPTED_EXTENSIONS.join(',')

export function isImportableFile(file: File): boolean {
  const name = file.name.toLowerCase()
  return ACCEPTED_EXTENSIONS.some(ext => name.endsWith(ext))
}

class ImportService {
  async parseFile(file: File): Promise<ParsedImport> {
    const isKmz = file.name.toLowerCase().endsWith('.kmz')
    const data = isKmz ? await file.arrayBuffer() : await file.text()
    return parseImportFile(data, file.name)
  }
}

export const importService = new ImportService()
